import { SideHeaderProps } from 'containers/ChannelManagement/Channel/ChannelForm/Tabs/Reports/FtpContainer/CsrReportPreview/types';

export const SIDE_HEADERS: SideHeaderProps = {
	merchantId: 'RT101',
	businessName: 'Radius Telecoms Inc',
	merchantName: 'Radius Telecoms Inc',
	generationDate: '08/27/2021',
};
